module.exports = __webpack_public_path__ + "img/kachel-ZAHNMUND_ALOEVERAZAHNGEL.dad2d17a.png";